export const EXTERNAL_ROUTE_PATHS = {
  COVERAGE_MAP: "https://www.t-mobile.com/coverage/coverage-map",
  TMO_LEGAL: "https://www.t-mobile.com/responsibility/legal/terms-and-conditions",
  INTERNET_POLICY: "https://www.t-mobile.com/responsibility/consumer-info/policies/internet-service"
}
